<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">通告列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">通告動態</li>
              <li class="breadcrumb-item active">通告列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button
                @click="selectByType('')"
                :class="{ current: '' == selectValue }"
                >全部</el-button
              >
              <el-button
                @click="selectByType('StopPublish')"
                :class="{ current: 'StopPublish' == selectValue }"
                >停止刊登</el-button
              >
            </div>
          </div>
          <div class="col-sm-2">
            <button
              @click="add"
              type="button"
              class="btn btn-block btn-primary btn-sm"
            >
              <i class="nav-icon fas fa-pen fa-sm mr-1"></i>新增
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="操作" prop="">
                    <template slot-scope="scope">
                      <!-- <el-button
                        v-if="scope.row.sgL_Status === 'Inpublish'"
                        type="primary"
                        size="mini"
                        @click="delfunc(scope.row.id)"
                        >停止刊登</el-button
                      >
                      <el-button
                        v-else
                        type="primary"
                        size="mini"
                        @click="addOrUpdate(scope.row.id)"
                        >開始刊登</el-button
                      > -->
                      <el-button
                        type="primary"
                        size="mini"
                        @click="edit(scope.row.id)"
                        >編輯</el-button
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="通知標題" prop="sgL_Title">
                  </el-table-column>
                  <el-table-column label="刊登狀態" prop="sgL_Status">
                    <template slot-scope="scope">
                      <span v-if="scope.row.sgL_Status === 'UrgentPublication'"
                        >緊急刊登</span
                      >
                      <span v-if="scope.row.sgL_Status === 'Inpublish'"
                        >刊登中</span
                      >
                      <span v-if="scope.row.sgL_Status === 'StopPublish'"
                        >停止刊登</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="用戶查閱" prop="sgL_ViewCount">
                  </el-table-column>
                  <el-table-column label="操作者" prop="sgL_UpdateName">
                  </el-table-column>
                  <el-table-column
                    label="建立時間"
                    prop="sgL_CreateTimeS"
                  ></el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-12" style="display: flex; justify-content: end">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      searchText: "",
      selectValue: "",
      BannerList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getBannerList();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    edit(id) {
      this.$router.push({
        name: "AdminNotificationDetail",
        query: {
          id,
        },
      });
    },
    add() {
      this.$router.push({
        name: "AdminNotificationDetail",
      });
    },
    getBannerList() {
      this.loading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        sgL_Status: this.selectValue,
        SGL_Type: "ALL",
      };
      this.$api.BannerApi.AdminSystemNoticeGetAll(params)
        .then((res) => {
          if (res.data.success) {
            this.BannerList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    selectByType(status) {
      this.selectValue = status;
    },
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getBannerList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.BannerList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}

/* .b-ad-name a {
  display: inline-block;
  position: relative;
}
.b-ad-name a img {
  display: none;
  position: absolute;
  z-index: 1100;
  min-height: 90px;
  max-height: 500px;
  top: 50%;
  left: calc(100% + 1rem);
  transform: translateY(-50%);
} */
</style>


// WEBPACK FOOTER //
// src/components/AdminNotification/list.vue